import React, { useState } from "react";
import Bubble from "../components/Bubble/Bubble";
import Button from "../components/Button/Button";
import IconRow from "../components/IconRow/IconRow";
import Slider from "../components/Slider/Slider";
import Navbar from "../components/Navbar/Navbar";
import TextImage from "../components/TextImage/TextImage";
import TeamCard from "../components/TeamCard/TeamCard";
import "./Home.css";
import fetchData from "../js/fetchData";
import { useEffect } from "react";
import Footer from "../components/Footer/Footer";

function Home() {
  const [state, setState] = useState(0);
  const [stakeData, setStakeData] = useState({
    total: "...",
    percentage: "...",
  });

  useEffect(() => {
    async function update() {
      const total = await fetchData("/api/staking/bears/total");
      const percentage = Math.round((total / 4444) * 100);
      setStakeData((prev) => ({
        ...prev,
        total: total,
        percentage: percentage.toFixed(0),
      }));
    }
    update();
  }, []);

  return (
    <>
      <Navbar state={state} setState={setState} />
      <div className="home">
        <div className="first-wrapper dark-background">
          <section className="container">
            {state === 0 ? (
              <>
                <TextImage
                  header="Baller Bears"
                  text="A community is built off the backbone of power & freedom, putting 4444 bears on the Ethereum blockchain."
                  image={require("../images/bear-mascot.png")}
                  extra={<IconRow />}
                />
                <div className="slider-container">
                  <div>
                    <p>50% Staked</p>
                    <p>Stake to earn $HNY</p>
                    <p>2222/4444</p>
                  </div>
                  <Slider value={stakeData.percentage} />
                </div>
                <Bubble
                  component1={
                    <Button
                      text="Stake your Bears"
                      onClick={() => {
                        window.location.href = "/stake";
                      }}
                    />
                  }
                  component2={
                    <a
                      href="https://opensea.io/collection/ballerbearsnft"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button text="Buy on OpenSea" onClick={() => {}} />
                    </a>
                  }
                />
              </>
            ) : (
              ""
            )}
          </section>
        </div>

        <div className="light-background">
          <section className="about team-container container">
            <h1>About Baller Bears</h1>
            <p>
              Baller Bears are a collection of 4444 NFTs hosted on the Ethereum
              blockchain. The Baller Bears community is built off the backbone
              of power & freedom. Using their stunning wits, they found a way to
              yield precious $HNY token through staking. These $HNY tokens act
              as our digital currency which can be used to mint future
              collections, and is fueled by secondary market royalties. The
              Bears were founded by a team of truly passionate artists &
              marketers who see Baller Bears potential as one of the most
              prevalent NFTs of our generation.
            </p>
          </section>
        </div>

        <div className="dark-background">
          <section className="team-container container">
            <h1>Roadmap</h1>
            <img src={require("../images/roadmap.png")} alt="Roadmap" />
          </section>
        </div>

        <div className="light-background">
          <section className="team-container container">
            <h1>Meet the Team</h1>
            <div className="team-card-container">
              <TeamCard
                image={require("../images/team/tan.webp")}
                name="Tan Choudhury"
                title="Lead Marketing"
              />
              <TeamCard
                image={require("../images/team/reece.webp")}
                name="Reece Hunter"
                title="Head Developer"
              />
              <TeamCard
                image={require("../images/team/cathy.webp")}
                name="Cathy Fabian"
                title="Project Manager"
              />
              <TeamCard
                image={require("../images/team/claire.webp")}
                name="Claire Aragon"
                title="Creative Consultant"
              />
              <TeamCard
                image={require("../images/team/noreen.webp")}
                name="Noreen Datu"
                title="Graphic Designer"
              />
              <TeamCard
                image={require("../images/team/hmilaroo.webp")}
                name="HMILAROO"
                title="Graphic Artist"
              />
            </div>
          </section>
        </div>

        <div className="dark-background">
          <section className="join team-container container">
            <h1>Join the Sleuth</h1>
            <p>
              Want to learn more about us? The Baller Bears community is always
              accepting new members with welcoming arms. Join our Discord server
              to get started!
            </p>
            <a
              href="https://discord.gg/sRpvtuywUt"
              rel="noreferrer"
              target="blank"
            >
              <button className="mid-button">Get Started</button>
            </a>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Home;
